import { get, internalDestroy, internalPost, internalPut } from '.';
import qs from 'qs';

export const getKinds = ({ filters }) => get(`/kinds?${qs.stringify(filters)}`);

export const getKind = ({ kindId, locale, skip }) => {
  if (skip) {
    return;
  }
  return get(`/kinds/${kindId}?locale=${locale}`);
};

export const createKind = ({ payload, locale }) => {
  return internalPost(`/kinds?locale=${locale}`, payload);
};

export const updateKind = ({ kindId, payload, locale }) => {
  return internalPut(`/kinds/${kindId}?locale=${locale}`, payload);
};

export const deleteKind = ({ kindId, payload }) => {
  return internalDestroy(`/kinds/${kindId}`, payload);
};
